import React from 'react';
import Button from '../../Button';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import useTranslations from '../../../hooks/useTranslations';
import Select from '../../engine/SelectEngine';
import styled from 'styled-components/macro';
import { Actions } from '../engine/AutomationsActionsEngine';
import Animation from '../../Animation';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import RemoveIcon from '@material-ui/icons/Remove';
import EmailConfEngine from '../actions/engine/EmailConfEngine';
import ShareWithEngine from '../actions/engine/ShareWithEngine';
import SetResponsibleAdminEngine from '../actions/engine/SetResponsibleAdminEngine';
import ChangeAssignedUserEngine from '../actions/engine/ChangeAssignedUserEngine';
import ChangeStatusEngine from '../actions/engine/ChangeStatusEngine';
import ChangeValueEngine from '../actions/engine/ChangeValueEngine';
import SendWebhookEngine from '../actions/engine/SendWebhookEngine';

const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const AddActionBtn = styled(Button)`
  && {
    margin-right: auto;
    margin-left: 0;
  }
`;

const ActionRow = styled.div`
  display: flex;
  opacity: ${({ $underDeleteHover }) => ($underDeleteHover ? '0.33' : '1')};
  transition: 0.2s;
`;

const AutomationsActionsView = props => {
  const t = useTranslations();
  return (
    <>
      <ActionsContainer>
        {props.actions.map(action => (
          <div key={action._id}>
            <Animation type="collapse">
              <ActionRow
                $underDeleteHover={props.underDeleteHover === action._id}
              >
                <div>
                  <Select
                    placeholder={t('automaions.wizard.actions.placeholder')}
                    value={action.actionType}
                    onChange={value => props.updateAction(action._id, value)}
                    options={[
                      {
                        value: Actions.STATUS_CHANGE,
                        text: t('automaions.wizard.actions.fieldupdate'),
                        'data-testid': 'fieldupdate',
                        disabled: props.isOptionDisabled(Actions.STATUS_CHANGE)
                      },
                      {
                        value: Actions.VALUE_CHANGE,
                        text: t('automaions.wizard.actions.valueupdate'),
                        'data-testid': 'valueupdate'
                      },
                      {
                        value: Actions.ADMIN,
                        text: t('automaions.wizard.actions.assign_to_admin'),
                        'data-testid': 'assign_to_admin',
                        disabled: props.isOptionDisabled(Actions.ADMIN)
                      },
                      {
                        value: Actions.SHARE,
                        text: t('automaions.wizard.actions.share'),
                        'data-testid': 'share'
                        // disabled: props.isOptionDisabled(Actions.SHARE)
                      },
                      {
                        value: Actions.ASSIGN_TO_USER,
                        text: t('automaions.wizard.actions.assignedUser'),
                        'data-testid': 'assignedUser',
                        disabled: props.isOptionDisabled(Actions.ASSIGN_TO_USER)
                      },
                      {
                        value: Actions.EMAIL,
                        text: t('automaions.wizard.actions.email'),
                        'data-testid': 'email',
                        disabled: props.isOptionDisabled(Actions.EMAIL)
                      },
                      {
                        value: Actions.WEBHOOK,
                        text: t('automaions.wizard.actions.webhook'),
                        'data-testid': 'email',
                        disabled: props.isOptionDisabled(Actions.WEBHOOK)
                      }
                    ]}
                  />
                </div>

                <AdditionalDropdown
                  {...props}
                  {...action}
                  update={payload => props.updateSubAction(action._id, payload)}
                />
                {/* <div> */}
                {/* figure out how to position this */}
                <Tooltip
                  arrow
                  title={t('automaions.wizard.actions.remove_action')}
                  style={{ marginLeft: 'auto' }}
                >
                  <IconButton
                    size="small"
                    onClick={() => props.removeAction(action._id)}
                    onMouseOver={() => props.setUnderDeleteHover(action._id)}
                    onMouseLeave={() => props.setUnderDeleteHover(null)}
                  >
                    <RemoveIcon />
                  </IconButton>
                </Tooltip>
                {/* </div> */}
              </ActionRow>
            </Animation>
          </div>
        ))}
        <AddActionBtn
          disabled={props.actions.length >= Object.keys(Actions).length}
          startIcon={<AddCircleOutlineIcon />}
          variant="text"
          onClick={props.addNewAction}
        >
          {t('automaions.wizard.actions.new')}
        </AddActionBtn>
      </ActionsContainer>
    </>
  );
};

export const AdditionalDropdown = ({
  actionType,
  update,
  variant,
  ...props
}) => {
  const dropdownFactory = {
    [Actions.STATUS_CHANGE]: (
      <ChangeStatusEngine variant={variant} update={update} {...props} />
    ),
    [Actions.VALUE_CHANGE]: (
      <ChangeValueEngine variant={variant} update={update} {...props} />
    ),
    [Actions.ADMIN]: (
      <SetResponsibleAdminEngine variant={variant} update={update} {...props} />
    ),
    [Actions.SHARE]: (
      <ShareWithEngine variant={variant} update={update} {...props} />
    ),
    [Actions.ASSIGN_TO_USER]: (
      <ChangeAssignedUserEngine variant={variant} update={update} {...props} />
    ),
    [Actions.EMAIL]: (
      <EmailConfEngine variant={variant} update={update} {...props} />
    ),
    [Actions.WEBHOOK]: (
      <SendWebhookEngine variant={variant} update={update} {...props} />
    )
  };

  return dropdownFactory[actionType] || null;
};

export default AutomationsActionsView;
